import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export function getBannersListsAPI(data) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/admin/banner/pagination?${getQueryString(data)}`);
}

export function getsingleBannerAPI( id) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/admin/banner/${id}`);
}


export function updateBannerListAPI(data, id) {
    if (id) {
        return (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`api/v1/admin/banner/${id}`, data);
    }
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).post('api/v1/admin/banner', data);
}

export function deleteBannerAPI(id) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`api/v1/admin/banner/${id}`)
}
